import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c7bfba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom_note_box" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "個人情報保護方針"),
  /*#__PURE__*/_createElementVNode("p", null, " 株式会社MedicalWEB（以下、「当社」といいます）は、お客様を含む当社と関係する個人にかかる個人情報保護の重要性及びその社会的責任の重大性を認識し、当社が当社の事業のために取得し利用するすべての個人情報を適切に取扱うため、当社全従業者が遵守すべき行動基準として本個人情報保護方針を定め、その遵守の徹底を図ることといたします。 "),
  /*#__PURE__*/_createElementVNode("h3", null, "１、法令遵守"),
  /*#__PURE__*/_createElementVNode("p", null, "当社は、個人情報の取扱いにあたり、関連する法令、国が定める指針その他の規範を遵守します。"),
  /*#__PURE__*/_createElementVNode("h3", null, "２、個人情報の取得、利用及び提供"),
  /*#__PURE__*/_createElementVNode("p", null, " 当社は、事業の内容及び規模を考慮した適切な個人情報の取得、利用及び提供を行います。それには特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行わないこと及びそのための措置を講じることを含みます。 "),
  /*#__PURE__*/_createElementVNode("h3", null, "３、委託"),
  /*#__PURE__*/_createElementVNode("p", null, " 当社は、個人情報の利用目的を達成するために必要な範囲において、当社が取得した個人情報の取扱いの全部又は一部を第三者に委託することがあります。この場合、当該委託にかかる個人情報の安全管理が図られるよう、委託先である第三者に対する必要かつ適切な監督を行います。 "),
  /*#__PURE__*/_createElementVNode("h3", null, "４、第三者への提供"),
  /*#__PURE__*/_createElementVNode("p", null, "当社は、本人の同意がある場合又は法令に基づく場合を除き、個人情報を第三者に提供することはありません。"),
  /*#__PURE__*/_createElementVNode("h3", null, "５、安全管理のための措置"),
  /*#__PURE__*/_createElementVNode("p", null, " 当社は、個人データへの不正アクセス又は個人データの漏えい、滅失又は毀損の防止その他の個人データの安全管理のために、技術的及び組織的に厳重なセキュリティ対策を講じます。当社は個人データの保護を継続的・向上的に行っていくため、当社が定めた社内規程等を法令及び社会規範の変化に合わせて見直し、改善をしていきます。 "),
  /*#__PURE__*/_createElementVNode("h3", null, "６、苦情及び相談対応"),
  /*#__PURE__*/_createElementVNode("p", null, " 当社は、個人情報の取扱いに関する苦情及び相談への適切かつ迅速な対応に努めます。また、当社の保有個人データの開示等の請求等(利用目的の通知、開示又は第三者提供記録の開示、訂正・追加又は削除、利用又は提供の停止、消去）を受け付けます。開示等の請求等の手続きにつきましては、以下の「個人情報苦情及び相談窓口」までご連絡ください。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "privacy-box" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "【個人情報苦情及び相談窓口】"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 株式会社MedicalWEB"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 苦情及び相談窓口責任者 内田 祐吾"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 電話 :045-577-9151"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" FAX :045-577-9152"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" メール :info@medicalweb.co.jp"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" （受付時間 月曜日～金曜日 祝祭日を除く 10時00分～18時00分） ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h2", null, "個人情報の取扱いについて"),
  /*#__PURE__*/_createElementVNode("p", null, " 当社は、以下に記載のとおり個人情報を適切に取り扱います。また、特定個人情報の利用については、「行政手続における特定の個人を識別するための番号の利用等に関する法律」（以下、「マイナンバー法」といいます）、その他特定個人情報の適正な取り扱いに関する関係諸法令及びガイドライン等の定めに従って利用し取り扱います。 "),
  /*#__PURE__*/_createElementVNode("h3", null, "７、個人情報の利用目的"),
  /*#__PURE__*/_createElementVNode("p", { class: "m_b_0" }, [
    /*#__PURE__*/_createTextVNode(" 当社が取得したお客様等の個人情報は以下の目的のために利用します。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("(1) 保有個人データと利用目的 ")
  ]),
  /*#__PURE__*/_createElementVNode("table", null, [
    /*#__PURE__*/_createElementVNode("tbody", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "個人情報の種類"),
        /*#__PURE__*/_createElementVNode("td", null, "利用目的")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createElementVNode("ul", { class: "table_ul" }, [
            /*#__PURE__*/_createElementVNode("li", null, "当社のWebサイト上でのお問い合わせ、資料請求、ダウンロード時にご入力いただく個人情報"),
            /*#__PURE__*/_createElementVNode("li", null, "当社Webサイト上での閲覧履歴等のアクセス情報"),
            /*#__PURE__*/_createElementVNode("li", null, "当社が実施するセミナーおよびキャンペーンへのお申し込み時にご入力いただく個人情報")
          ])
        ]),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createTextVNode(" (1)当該お問い合わせ対応、資料請求、ダウンロードに付帯する連絡"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" (2)営業活動、広告の配信、表示及び効果測定"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" ※これには、お客様からのお問い合わせの内容等を、取得した閲覧履歴等のアクセス情報と突合し、ご要望等の分析を行ったうえで、その結果に基づいて営業活動や広告配信等を行うことを含みます。 ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "お取引先様各社、他社の役員・社員等の方に関する個人情報"),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createTextVNode(" (1)業務上必要な諸連絡・商談等"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" (2)取引先情報管理、支払・収入処理"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" (3)広告の配信、表示及び効果測定 ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "当社求人への採用応募者の履歴書等の個人情報"),
        /*#__PURE__*/_createElementVNode("td", null, "(1)採用選考・内定者管理")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "当社役員・従業員及びその親族の個人情報"),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createTextVNode(" (1)業務連絡、雇用管理、税・社会保障手続き・給与支払い管理、人事考課、健康管理、労務管理"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" (2)当社ホームページの会社概要、及び業務紹介ページ等への掲載"),
          /*#__PURE__*/_createElementVNode("br")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "特定個人情報"),
        /*#__PURE__*/_createElementVNode("td", null, [
          /*#__PURE__*/_createTextVNode(" マイナンバー法で定められた個人番号を取り扱う事務の範囲内でのみ取り扱い、利用します。"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" また、人の生命、身体又は財産の保護のために必要がある場合を除き、本人の同意があったとしても、利用目的を超えて特定個人情報を利用しません。 ")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "m_b_0" }, "2. 上記以外で取り扱う個人データと利用目的"),
  /*#__PURE__*/_createElementVNode("table", null, [
    /*#__PURE__*/_createElementVNode("tbody", null, [
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "項目"),
        /*#__PURE__*/_createElementVNode("td", null, "利用目的")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "当社の提供サービスに格納されたお客様の個人情報"),
        /*#__PURE__*/_createElementVNode("td", null, "(1)提供サービスの運営")
      ]),
      /*#__PURE__*/_createElementVNode("tr", null, [
        /*#__PURE__*/_createElementVNode("td", null, "人材紹介会社・サービスから受け取った採用応募者の履歴書等の個人情報"),
        /*#__PURE__*/_createElementVNode("td", null, "(1)採用選考・内定者管理")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h3", null, "８、個人情報の利用目的の通知、開示、訂正等請求"),
  /*#__PURE__*/_createElementVNode("p", null, " 当社は、当社が保有する個人情報について、利用目的の通知、開示（第三者提供記録を含む）、訂正・追加又は削除、利用又は第三者提供の停止の請求（以下、「開示等請求」といいます）に対応しております。手続の内容につきましては、以下の「個人情報苦情及び相談窓口」までご連絡ください。遅滞なく回答いたします。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "privacy-box" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "【個人情報苦情及び相談窓口】"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 〒220-0004"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 神奈川県横浜市西区北幸2丁目10番27号"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 東武立野ビル601"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 株式会社MedicalWEB"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 苦情及び相談窓口責任者 内田 祐吾"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" 電話 :045-577-9151"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" FAX :045-577-9152"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" メール :info@medicalweb.co.jp"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" （受付時間 月曜日～金曜日 祝祭日を除く 10時00分～18時00分） ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h3", null, "９、開示等請求の様式、方式等"),
  /*#__PURE__*/_createElementVNode("p", { class: "m_b_0" }, "＜開示等の請求等に際して提出を頂く書面の様式及び方式＞"),
  /*#__PURE__*/_createElementVNode("p", null, " 下記の書類及び資料を前記の「個人情報苦情及びご相談窓口」まで、郵便又は宅配便でご送付ください。遅滞なく迅速に対応いたします。なお郵便又は宅配便以外の手段（直接のご来社、電子メール、FAXなど）での開示等の請求等は受け付けておりません。 "),
  /*#__PURE__*/_createElementVNode("ol", { class: "parentheses" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" 当社指定の「開示等の請求等申請書」"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" ※ご連絡いただければこちらからお送りいたします。 ")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode(" 本人確認書類 "),
      /*#__PURE__*/_createElementVNode("ol", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createTextVNode(" a) ご本人によるお申し込みの場合"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" 本人の公的証明書（運転免許証・パスポート・住民基本台帳カード・在留カード又は特別永住者証明書・マイナンバーカード（顔写真入りの表面のみ）・その他本人確認できる公的証明書のいずれか）の写し1通 ")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createTextVNode(" b) 代理人によるお申し込みの場合 "),
          /*#__PURE__*/_createElementVNode("ol", null, [
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode(" ① 代理権確認書類"),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createElementVNode("span", { class: "indent6" }, "法定代理人 :戸籍謄本その他その資格を証明する書類"),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createElementVNode("span", { class: "indent6" }, [
                /*#__PURE__*/_createTextVNode("任意代理人 :i 当社社指定の委任状"),
                /*#__PURE__*/_createElementVNode("br"),
                /*#__PURE__*/_createTextVNode(" ※印鑑登録された本人の実印が捺印されたもの。"),
                /*#__PURE__*/_createElementVNode("br"),
                /*#__PURE__*/_createTextVNode(" ii 本人の印鑑登録証証明書")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode(" ② 代理人の身元確認書類"),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createTextVNode(" 代理人の公的証明書（前記(2)、a）と同様です） ")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createTextVNode(" ③ 本人の身元確認書類"),
              /*#__PURE__*/_createElementVNode("br"),
              /*#__PURE__*/_createTextVNode(" 本人の公的証明書（前記(2)、aと同様です） ")
            ])
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "m_b_0" }, "＜手数料＞"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 利用目的の通知又は開示の請求の場合にのみ、返信のための事務手数料及び郵送費相当の手数料として１回のご請求毎に、2,000円（税込）の手数料をいただきます。同額の郵便小為替を上記書類とあわせてご同封ください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 郵便小為替のご購入のための料金及び「個人情報開示等請求書」等の郵送料はお客様にてご負担ください。 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "m_b_0" }, "＜注意事項＞"),
  /*#__PURE__*/_createElementVNode("ul", { class: "disc" }, [
    /*#__PURE__*/_createElementVNode("li", null, " 提出いただいた書類に不備があった場合、手数料が不足又は同封されていなかった場合は、追完のための期間を指定してその旨をご連絡します。当該期間内に書類の追完や手数料の支払がなかった場合は、開示等のご請求がなかったものとして対応させていただきます。 "),
    /*#__PURE__*/_createElementVNode("li", null, "郵送や配送途中の書類の紛失、事故による未着につきましては、当社では責任を負いかねます。"),
    /*#__PURE__*/_createElementVNode("li", null, "必要事項を全てご記入下さい。書類に不備がある場合は、返送させていただく場合がございます。"),
    /*#__PURE__*/_createElementVNode("li", null, "個人情報保護法の例外規定にあたる場合など、開示等の請求等にお答えできない場合がございます。"),
    /*#__PURE__*/_createElementVNode("li", null, "内容により、お時間をいただく場合がございます。"),
    /*#__PURE__*/_createElementVNode("li", null, " 開示等の請求等にともない収集した個人情報は、開示等の請求等の必要な範囲のみで取扱うものとします。提出していただいた書面は当社で適切に廃棄いたします。なお、送付頂いた書類は原則としてご返却いたしません。 "),
    /*#__PURE__*/_createElementVNode("li", null, " 当社が保有するお客様の個人情報の訂正・追加又は削除、利用の停止等に応じた結果、一部サービスがご利用いただけなくなることがあります。あらかじめご了承下さい。 ")
  ]),
  /*#__PURE__*/_createElementVNode("h3", null, "１０、改定"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 本プライバシーポリシーは、当社の裁量に基づき、随時改定されることがあります。但し、個人情報保護法その他の法令により改定に必要な手続が定められている場合には、当該法令に基づき改定を行うものとします。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 本プライバシーポリシーが変更された場合、当社は、お客様に対し、変更後の本ポリシーの施行時期及び内容を以下の方法で周知します。 ")
  ]),
  /*#__PURE__*/_createElementVNode("ol", { class: "parentheses" }, [
    /*#__PURE__*/_createElementVNode("li", null, "当社のWebサイトへの掲示"),
    /*#__PURE__*/_createElementVNode("li", null, "お客様への通知"),
    /*#__PURE__*/_createElementVNode("li", null, "その他適切な方法")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("制定 :2024年 1月 1日")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "m_b_0" }, "株式会社MedicalWEB"),
  /*#__PURE__*/_createElementVNode("p", null, "代表取締役社長 内田祐吾")
], -1))

import LayoutComponent from "@/clinic/views/static/layout/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyPolicy',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutComponent, null, {
    title: _withCtx(() => [
      _createTextVNode("プライバシーポリシー")
    ]),
    content: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})